// extracted by mini-css-extract-plugin
module.exports = {"root":"CategoryService_root__rEXvL","label":"CategoryService_label__2Elzm","location":"CategoryService_location__3CrXx"};